import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DevicesView from '../components/DevicesView';
import { Device } from '../models/device';
import { fetchDevices, pingDevice } from '../lib/deviceStubs';

// Capability-gated Devices section. Access is gated by the MANAGE_DEVICES
// capability via PrivateRoute (see App.tsx); the data APIs that live here must
// independently enforce that capability server-side.
//
// Data + API are currently STUBBED (see lib/deviceStubs.ts). When the GraphQL
// `devices` query / `pingDevice` mutation exist, swap the fetch/ping calls below
// for `useQuery` / `useMutation` — the props handed to <DevicesView> stay the
// same. Orders.tsx is the reference for the Apollo wiring.
export default () => {
  const [devices, setDevices] = useState<Device[] | null>(null);
  const [pinging, setPinging] = useState<Record<string, boolean>>({});

  useEffect(() => {
    let active = true;
    fetchDevices().then((result) => {
      if (active) setDevices(result);
    });
    return () => {
      active = false;
    };
  }, []);

  const onPing = (device: Device) => {
    setPinging((prev) => ({ ...prev, [device.id]: true }));
    pingDevice(device).then((updated) => {
      setDevices((prev) =>
        (prev || []).map((d) => (d.id === updated.id ? { ...updated, cameras: d.cameras } : d))
      );
      setPinging((prev) => {
        const next = { ...prev };
        delete next[device.id];
        return next;
      });
    });
  };

  if (!devices) {
    return (
      <StyledLoading>
        <h1>Devices</h1>
        <p>Loading devices…</p>
      </StyledLoading>
    );
  }

  return <DevicesView devices={devices} pinging={pinging} onPing={onPing} />;
};

const StyledLoading = styled.div`
  margin: 44px 52px 0;
  color: #595959;
  font-family: Helvetica, sans-serif;
`;
